import { QuestionnaireFieldRes } from './questionnaire-field-res'

export interface QuestionnaireResInterface {
  fields: QuestionnaireFieldRes[]
  questionnaireId: number
}

export class QuestionnaireRes implements QuestionnaireResInterface {
  fields: QuestionnaireFieldRes[]
  questionnaireId: number

  constructor(props: QuestionnaireResInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      fields: _fields,
      questionnaireId: _questionnaireId,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.fields = _fields
      ? _fields.map((i) => new QuestionnaireFieldRes(i))
      : _fields
    this.questionnaireId = _questionnaireId
  }
}
